import React from "react";
import CompaniesGrid from "../../panels/companies/CompaniesGrid";

export default function CompaniesPage() {
    return (
        <CompaniesGrid/>
    )
}
